import React from 'react';
import { formatDate } from '../../utils/dateUtils';
import { DIAGNOSIS_META } from './constants';

// One parcel's answer from the quick check: the chip, and — when the system
// knows — the box and round so the admin can answer the customer right away.
const DiagnosisChip = ({ diagnosis, withDetail = true }) => {
  if (!diagnosis) return <span className="text-gray-300">—</span>;
  const meta = DIAGNOSIS_META[diagnosis.flag] || { label: diagnosis.flag, cls: 'bg-gray-100 text-gray-700', hint: '' };
  const round = diagnosis.shipRound;
  return (
    <span className="inline-flex flex-col gap-0.5" title={meta.hint}>
      <span className={`text-xs px-2 py-0.5 rounded-full font-medium w-fit ${meta.cls}`}>{meta.label}</span>
      {withDetail && (diagnosis.box || round) && (
        <span className="text-xs text-gray-500">
          {diagnosis.box ? `${diagnosis.box}` : ''}
          {round ? ` · รอบ ${round.isAir ? '✈️' : '🚢'} ${formatDate(round.shipDate)}` : ''}
          {diagnosis.arrivedDate ? ` · ถึง JP ${formatDate(diagnosis.arrivedDate)}` : ''}
        </span>
      )}
    </span>
  );
};

export default DiagnosisChip;
